import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { fadeAndSlideUp } from '@smartera/animations';
import { BaseComponent } from '@modules/components/base-component';

import { UtilityService } from '@core/services/utility.service';
import { AuthenticationUrls } from '../models';

export class ResetUser {
	public password: string;
	public confirmPassword: string;
}

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
	animations: [fadeAndSlideUp],
	standalone: false,
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {
	private resetPath: string = AuthenticationUrls.ResetPassword;

	public form: FormGroup;
	public registerKey: string;
	public registerEmail: string;
	public resetUser: ResetUser = new ResetUser();
	public patternError = '';

	constructor(
		private _http: HttpClient,
		private _route: ActivatedRoute,
		private _router: Router,
		utilServ: UtilityService
	) {
		super(null, utilServ);
		this.form = new FormGroup(
			{
				password: new FormControl('', [Validators.required]),
				confirmPassword: new FormControl('', [Validators.required]),
			},
			passwordMatchValidator
		);

		function passwordMatchValidator(g: FormGroup) {
			return g.get('password').value === g.get('confirmPassword').value ? null : { mismatch: true };
		}
	}

	public ngOnInit() {
		this._route.params.subscribe((params: Params) => (this.registerEmail = params.email));
		this._route.params.subscribe((params: Params) => (this.registerKey = params.activation));
		this.hideloader();
	}

	public sendResetLink(value: any, btn?) {
		this._http
			.get(
				this.resetPath +
					'?email=' +
					encodeURIComponent(this.registerEmail) +
					'&key=' +
					encodeURIComponent(this.registerKey) +
					'&password1=' +
					encodeURIComponent(value.password) +
					'&password2=' +
					encodeURIComponent(value.confirmPassword)
			)
			.subscribe(
				(data: any) => {
					this.patternError = '';
					// this._router.navigateByUrl('/login');
					// this.utilServ.alertService.success(this.t('alert.title.success'), this.t('alert.message.succesfully-password-changed')); // password changed

					this.utilServ.confirmationService.confirm({
						message: this.t('alert.message.succesfully-password-changed'),
						accept: () => this._router.navigateByUrl('/login'),
						rejectVisible: false,
						header: this.t('alert.title.success'),
						acceptLabel: this.t('g.ok'),
					});
				},
				(errRespond) => {
					if (errRespond && errRespond.error && errRespond.error.message) {
						console.log('=>', errRespond.error.message);
						this.patternError = errRespond.error.message;
					}
				}
			);
	}
}
